// extracted by mini-css-extract-plugin
export default {"error_page":"no-match_error_page__W2teH"};